import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { ButtonMenu, ButtonMenuItem } from '@pancakeswap-libs/uikit'
import TranslatedText from '../TranslatedText'

const StyledNav = styled.div`
  margin-bottom: 40px;
`

const Nav = ({ activeIndex = 0 }: { activeIndex?: number }) => (
  <StyledNav>
    <ButtonMenu activeIndex={activeIndex} size="sm" variant="primary">
      <ButtonMenuItem id="swap-nav-link" to="/swap" as={Link}>
       <div style={{color:activeIndex === 0?"#000":""}}> <TranslatedText translationId={8}>Swap</TranslatedText></div>
      </ButtonMenuItem>
      <ButtonMenuItem id="pool-nav-link" to="/pool" as={Link}>
      <div style={{color:activeIndex === 1?"#000":""}}><TranslatedText translationId={74}>Liquidity</TranslatedText></div>
      </ButtonMenuItem>
      <ButtonMenuItem
        id="pool-nav-link"
        as="a"
        href="https://www.binance.org/en/panama"
        target="_blank"
        rel="noreferrer noopener"
      >
        <div style={{color:activeIndex === 2?"#000":""}}>Bridge</div>
        
      </ButtonMenuItem>
    </ButtonMenu>
  </StyledNav>
)

export default Nav
